import React from "react";
import { Link } from "react-router-dom";
import "./Landing.css";

export const Landing = () => {
  return (
    <div className="landing-container">
      <header className="hero-section">
        <h1 className="main-title">Subleazy</h1>
        <h2 className="subtitle">Subleasing Made Eazy</h2>
        <div className="hero-content">
          <h2 className="hero-title">Discover Your Ideal <span className="highlight">U of I</span> Sublease</h2>
          <p className="hero-text">
            At Subleazy, we understand that finding the perfect sublease can be stressful and time-consuming. 
            That's why we've designed our platform to make the process as simple as possible. With user-friendly 
            navigation and powerful search tools, you can swiftly filter listings to match your preferences, 
            helping you find a place that truly feels like home.
          </p>
          <div className="cta-buttons">
            <Link to="/register" className="cta-button">
              Post a Sublease
            </Link>
            <Link to="/home" className="cta-button outline">
              Find a Sublease
            </Link>
          </div>
          <p className="info-text">
            <i className="fas fa-info-circle"></i> You can browse listings without an account, but you'll need to register to post or save listings.
          </p>
        </div>
      </header>

      <section className="feature-section">
        <div className="feature-image">
          <img
            src="/subleazy.gif"
            alt="All Apartments in One Place"
            className="feature-gif"
          />
        </div>
        <div className="feature-content">
          <h3 className="feature-title">All Subleases in One Place</h3>
          <p className="feature-text">
            Explore a wide range of sublease listings from fellow students and residents. 
            Our platform empowers you to connect directly with listers, ensuring you find 
            opportunities that match your needs. Use our tools to make informed decisions 
            and feel confident in your choice.
          </p>
        </div>
      </section>

      <section className="feature-section reverse">
        <div className="feature-content">
          <h3 className="feature-title">Connect with Students</h3>
          <p className="feature-text">
          Effortlessly connect and communicate to plan your housing. 
          Our user-friendly interface ensures your posts reach a broad audience swiftly.
          </p>
        </div>
        <div className="feature-image">
          <img
            src="/image2.png"
            alt="Connect with Students"
            className="feature-img"
          />
        </div>
      </section>

      <section className="feature-section">
        <div className="feature-image">
          <img
            src="/image1.png"
            alt="Sign with Confidence"
            className="feature-img"
          />
        </div>
        <div className="feature-content">
          <h3 className="feature-title">Sign with Confidence</h3>
          <p className="feature-text">
          Subleazy is more than a platform; it's a community of students and residents in the UIUC area. 
          By choosing us, you gain access to exceptional subleases and connect with a network of peers 
          who share your experiences and needs. Together, we can make finding a sublease an enjoyable 
            and rewarding experience.
          </p>
        </div>
      </section>

      <footer className="landing-footer">
        <p className="footer-text">Subleasing Made Easy</p>
        <div className="footer-links">
          <a href="/terms" className="footer-link">Terms and Conditions</a>
          <span className="footer-separator">•</span>
          <a href="/privacy" className="footer-link">Privacy Policy</a>
        </div>
      </footer>
    </div>
  );
};
